/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import { push } from "react-router-redux";
import { Field, Form, withFormik } from "formik";
import Yup from "yup";
import { bool, node, shape, string } from "prop-types";

import { actions as transactionsActions } from "reducers/transactions";

import Button from "pages/_components/Button";
import AmountField from "pages/_components/fields/formik/AmountField";

import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import classNames from "classnames";
import { evalEqualsValues } from "util/form";
import { normalizeActivityId } from "util/transaction";

const FORM_ID = "transactions.list.filters.amount";

class AmountFilterPendingTransactions extends Component {
    static propTypes = {
        fetching: bool,
        buttonLabel: string,
        withSelector: bool,
        cleanFiltersButton: node,
        renderOrder: node,
        selectedFilter: string.isRequired,
        filters: shape({}).isRequired,
        isMobileMvp3: bool,
        isMvp3: bool,
        idActivity: string,
        minAmount: shape({}),
        maxAmount: shape({}),
        values: shape({
            minAmount: shape({}),
            maxAmount: shape({}),
        }),
    };

    static defaultProps = {
        fetching: false,
        buttonLabel: null,
        withSelector: false,
        cleanFiltersButton: null,
        renderOrder: null,
        isMobileMvp3: false,
        isMvp3: false,
        idActivity: null,
        minAmount: {},
        maxAmount: {},
        values: {
            minAmount: {},
            maxAmount: {},
        },
    };

    changeCurrencies = (value, form) => {
        form.setFieldValue(`maxAmount.currency`, value);
        form.setFieldValue(`minAmount.currency`, value);
    };

    render() {
        const {
            fetching,
            buttonLabel,
            withSelector,
            cleanFiltersButton,
            renderOrder,
            selectedFilter,
            filters,
            idActivity,
            minAmount,
            maxAmount,
            values,
            isMobileMvp3,
            isMvp3,
        } = this.props;
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        const currenciesAll = [{ id: 0, label: i18n.get(`currency.label.ARS`) }];
        const onCurrencyChange = withSelector ? this.changeCurrencies : false;
        const currency = withSelector ? currenciesAll[0] : null;

        if (withSelector) {
            currenciesAll.push({ id: 2, label: i18n.get(`currency.label.USD`) });
        }

        const buttonSection = (
            <Col
                sm={12}
                md={3}
                lg={3}
                className={classNames("d-flex f-dir-col mt-35 pt-3 position-relative", {
                    "pl-3": !isMobileMvp3,
                    "pl-0": isMobileMvp3,
                    "pr-0": isMobileMvp3,
                    "pr-3": !isMobileMvp3,
                })}>
                <Button
                    bsStyle="primary"
                    label={buttonLabel || "product.filters.filter"}
                    loading={fetching}
                    type="submit"
                    image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                    imageStyle="mr-2"
                    className={classNames("filter-button m-0  w-100", {
                        "text-transform-none": enableNewSubmitButton,
                    })}
                    disabled={
                        enableNewSubmitButton &&
                        (!selectedFilter ||
                            evalEqualsValues(
                                {
                                    activity: filters.idActivity,
                                    searchBy: filters.filter,
                                    minAmount: minAmount?.amount,
                                    maxAmount: maxAmount?.amount,
                                },
                                {
                                    minAmount: values.minAmount.amount,
                                    maxAmount: values.maxAmount.amount,
                                    activity: idActivity,
                                    searchBy: selectedFilter,
                                },
                            ))
                    }
                />
                {isMobileMvp3 ? (
                    cleanFiltersButton
                ) : (
                    <div className="pending-transactions__clean-filters-absolute">{cleanFiltersButton}</div>
                )}
            </Col>
        );

        const orderSection = (
            <Col
                sm={12}
                md={3}
                lg={3}
                className={classNames("d-flex f-dir-col px-0", {
                    "pl-3": !isMobileMvp3,
                })}>
                {renderOrder}
            </Col>
        );

        const amountFromSection = (
            <Col
                sm={12}
                md={3}
                lg={3}
                className={classNames("amount-filter__amounts", {
                    "pl-0": isMobileMvp3,
                    "pr-0": isMobileMvp3,
                })}>
                <Field
                    component={AmountField}
                    data={{ options: currenciesAll, onCurrencyChange }}
                    clearable={!withSelector}
                    currency={currency}
                    idForm={FORM_ID}
                    name="minAmount"
                    fixedDecimalScale
                />
            </Col>
        );

        const amountToSection = (
            <Col
                sm={12}
                md={3}
                lg={3}
                className={classNames("amount-filter__amounts", {
                    "pl-0": isMobileMvp3,
                    "pr-0": isMobileMvp3,
                })}>
                <Field
                    component={AmountField}
                    clearable={!withSelector}
                    data={{ options: currenciesAll, onCurrencyChange }}
                    currency={currency}
                    idForm={FORM_ID}
                    name="maxAmount"
                    fixedDecimalScale
                />
            </Col>
        );

        return (
            <Form className={isMvp3 ? "amount-filter--mvp3" : undefined}>
                {isMobileMvp3 ? (
                    <>
                        {orderSection}
                        {amountFromSection}
                        {amountToSection}
                        {buttonSection}
                    </>
                ) : (
                    <>
                        {buttonSection}
                        {orderSection}
                        {amountFromSection}
                        {amountToSection}
                    </>
                )}
            </Form>
        );
    }
}

export default withFormik({
    validateOnChange: false,
    validateOnBlur: false,
    mapPropsToValues: (props) => ({
        minAmount: props.minAmount ? props.minAmount : {},
        maxAmount: props.maxAmount ? props.maxAmount : {},
    }),
    validationSchema: () =>
        Yup.lazy((values) =>
            Yup.object().shape({
                minAmount: Yup.object().shape({
                    amount: values.maxAmount.amount
                        ? Yup.number()
                              .transform((cv, ov) => (ov === "" ? undefined : cv))
                              .nullable()
                              .max(values.maxAmount.amount, i18n.get("accounts.movements.filters.minAmount.error"))
                        : Yup.number()
                              .transform((cv, ov) => (ov === "" ? undefined : cv))
                              .nullable(),
                }),
                maxAmount: Yup.object().shape({
                    amount: values.minAmount.amount
                        ? Yup.number()
                              .transform((cv, ov) => (ov === "" ? undefined : cv))
                              .nullable()
                              .min(values.minAmount.amount, i18n.get("accounts.movements.filters.maxAmount.error"))
                        : Yup.number()
                              .transform((cv, ov) => (ov === "" ? undefined : cv))
                              .nullable(),
                }),
            }),
        ),
    handleSubmit: ({ ...filters }, formikBag) => {
        const {
            dispatch,
            isDesktop,
            onlyPendings,
            pendingDispatch,
            setFilterData,
            status,
            idActivity,
            cleanSelectedRows,
            filters: reduxFilters,
        } = formikBag.props;

        const { maxAmount, minAmount } = filters;
        const normalizedIdActivity = normalizeActivityId(idActivity);

        if (cleanSelectedRows) {
            cleanSelectedRows();
        }

        const getCurrency = (amount) => (amount.currency ? amount.currency : 0);

        maxAmount.currency = getCurrency(maxAmount);
        minAmount.currency = getCurrency(minAmount);

        if (setFilterData) {
            setFilterData({ maxAmount: maxAmount.amount, minAmount: minAmount.amount });
        } else if (isDesktop) {
            dispatch(
                transactionsActions.loadListRequest(
                    {
                        ...(reduxFilters || {}),
                        ...filters,
                        status,
                        idActivity: normalizedIdActivity,
                        maxAmount: { amount: maxAmount.amount, currency: maxAmount.currency },
                        minAmount: { amount: minAmount.amount, currency: minAmount.currency },
                        filter: "amount",
                        pageNumber: 1,
                    },
                    onlyPendings,
                    pendingDispatch,
                    "",
                    formikBag,
                ),
            );
        } else {
            dispatch(
                transactionsActions.setFilters({
                    ...(reduxFilters || {}),
                    filter: "amount",
                    ...filters,
                    maxAmount: { amount: maxAmount.amount, currency: maxAmount.currency },
                    minAmount: { amount: minAmount.amount, currency: minAmount.currency },
                    pageNumber: 1,
                }),
            );
            dispatch(push(`/transactions/list/filters/results`));
        }
    },
})(AmountFilterPendingTransactions);
